var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarbonHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5304 7.18501C18.3766 7.06511 18.1872 7 17.9922 7C17.7972 7 17.6078 7.06511 17.454 7.18501L5 16.896L6.07727 18.2584L7.6 17.0711V27.7995C7.60092 28.259 7.78383 28.6993 8.10869 29.0242C8.43356 29.349 8.87391 29.532 9.33333 29.5329H26.6667C27.1261 29.532 27.5664 29.349 27.8913 29.0242C28.2162 28.6993 28.3991 28.259 28.4 27.7995V17.0789L29.9227 18.2662L31 16.9038L18.5304 7.18501ZM19.7333 27.7995H16.2667V20.8662H19.7333V27.7995ZM21.4667 27.7995V20.8662C21.4667 20.4065 21.284 19.9656 20.959 19.6406C20.6339 19.3155 20.193 19.1329 19.7333 19.1329H16.2667C15.807 19.1329 15.3661 19.3155 15.041 19.6406C14.716 19.9656 14.5333 20.4065 14.5333 20.8662V27.7995H9.33333V15.7199L18 8.96861L26.6667 15.7286V27.7995H21.4667Z",
    fill: "#363C40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonHome);
export default __webpack_public_path__ + "static/media/carbon_home.adcc95f0dfad85a4fe5ddcdea4405f6b.svg";
export { ForwardRef as ReactComponent };